import Stack, { StackProps } from '@liquidweb-dev/undercurrent/Stack';
import SearchIcon from '@liquidweb-dev/undercurrent/icons/lucide/Search';
import HistoryIcon from '@liquidweb-dev/undercurrent/icons/lucide/History';
import BrickWallIcon from '@liquidweb-dev/undercurrent/icons/lucide/BrickWall';
import PowerIcon from '@liquidweb-dev/undercurrent/icons/lucide/Power';
import Button from '@liquidweb-dev/undercurrent/Button';
import HelpDocCard from './HelpDocCard';

const CloudVPSServerDetails = ({ ...rest }: StackProps) => {
	return (
		<Stack
			{...rest}
			sx={[
				{
					gap: 200,
				},
				...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
			]}
		>
			<HelpDocCard
				title="Getting Started with Cloud VPS"
				description="Get to know your VPS layout, stats, and server tools"
				link="https://docs.nexcess.com/hosting/hosting-services/cloud-vps/exploring-your-cloud-vps-infrastructure/"
				icon={SearchIcon}
			/>
			<HelpDocCard
				title="Creating a Backup"
				description="Learn how to create and manage VPS backups easily"
				link="https://docs.nexcess.com/hosting/hosting-services/cloud-vps/cloud-vps-backups/creating-a-backup-of-your-cloud-vps/"
				icon={HistoryIcon}
			/>
			<HelpDocCard
				title="Configuring Your Firewall"
				description="Control access by setting up custom firewall rules"
				icon={BrickWallIcon}
				link="https://docs.nexcess.com/hosting/security/firewall-management/cloud-firewall/configuring-your-cloud-firewall/"
			/>
			<HelpDocCard
				title="Reboot Your VPS"
				description="Safely restart your server when needed"
				icon={PowerIcon}
				link="https://docs.nexcess.com/hosting/hosting-services/cloud-vps/reboot-a-vps/"
			/>
			<Button
				variant="ghost"
				size="large"
				sx={() => ({ paddingY: 100 })}
				href="https://docs.nexcess.com/hosting/hosting-services/cloud-vps/"
				component="a"
				target="_blank"
				rel="noopener"
			>
				See all Cloud VPS Docs
			</Button>
		</Stack>
	);
};

export default CloudVPSServerDetails;
